import {
  Checkbox,
  Col,
  Row,
  Typography,
  Space,
  Collapse,
  Tag,
  Button,
  message,
} from "antd";
import classes from "./RIsksOpportunity.module.scss";
import { queryKeys } from "../../constants";
import { useParams } from "react-router-dom";
import { executeStrategy, getStrategyData } from "../../services/scenarios";
import { useMutation, useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loading";
import { useState } from "react";

const { Title } = Typography;

const RiskOpportunity = () => {
  const { id, category } = useParams();
  const [executedStrategy, setExecutedStrategy] = useState(null);

  const getStrategyDataQuery = useQuery({
    queryKey: [queryKeys.getStrategyData, id, category],
    queryFn: () => getStrategyData(id, category),
    enabled: true,
  });

  const executedStrategyMutation = useMutation({
    mutationFn: executeStrategy,
    onSuccess: () => {
      message.success("Strategy executed successfully");
      setExecutedStrategy(null);
      getStrategyDataQuery.refetch();
    },
    onError: (error) => {
      message.error(`An error occurred while executing the strategy`);
    },
  });

  const getColor = (urgency) => {
    switch (urgency) {
      case "High Priority":
        return "red";
      case "Urgent":
        return "warning";
      case "Strategic":
        return "blue";
      default:
        return "grey";
    }
  };

  const riskOpportunity = (item) => [
    {
      key: item.id,
      label: item.name,
      children: (
        <div>
          <ol className={classes.wtree}>
            <li style={{ margin: "-8px 0 10px 22px" }}>
              <span style={{ fontWeight: "bold" }}>{item.name} Plan Steps</span>
              <ol>
                {item?.steps?.map((i, index) => (
                  <li key={i.id}>
                    <span className={classes.titleContainer}>
                      #{index + 1} : {i}
                    </span>
                  </li>
                ))}
              </ol>
            </li>
            {item?.mitigation_plan && (
              <li style={{ margin: "2px 0 10px 22px" }}>
                <span style={{ fontWeight: "bold" }}>
                  {item.name} Mitigation Plan Steps
                </span>
                <ol>
                  {item?.mitigation_plan?.sections?.map((m, index) => (
                    <li key={m.id}>
                      <span className={classes.titleContainer} style={{ fontWeight: "600" }}>
                        {m.heading}
                      </span>
                      <ol>
                        {m?.details?.map((d, index) => (
                          <li key={d}>
                            <span className={classes.titleContainer}>
                              #{index + 1} : {d}
                            </span>
                          </li>
                        ))}
                      </ol>
                    </li>
                  ))}
                </ol>
              </li>
            )}
          </ol>
        </div>
      ),
      extra: (
        <Checkbox
          onChange={() => setExecutedStrategy(item)}
          checked={item.id === executedStrategy?.id || item.is_executed}
          disabled={item.is_executed}
        />
      ),
    },
  ];

  const uniqueRiskOpportunityIds = Array.from(
    new Map(
      getStrategyDataQuery?.data?.data?.map((obj) => [
        obj?.risk_opportunity?.id,
        obj,
      ])
    ).values()
  );

  return getStrategyDataQuery.isLoading ? (
    <Loader />
  ) : (
    <div>
      <div
        style={{
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <Row gutter={[8, 8]} align={"middle"}>
          <Col md={24} sm={24}>
            <Title level={3} style={{ marginTop: 0, marginBottom: 0 }}>
              Strategic Plan
            </Title>
          </Col>
          <Col md={24} sm={24}>
            <Title level={3} style={{ fontSize: "16px" }}>
              Category Name:{" "}
              {getStrategyDataQuery.data?.data?.[0]?.risk_opportunity
                ?.category_name ?? "-"}
            </Title>
          </Col>
        </Row>
        <Space
          direction="vertical"
          style={{
            margin: "10px 0",
            width: "100%",
          }}
        >
          {uniqueRiskOpportunityIds?.map((strategy) => {
            const specificRisksOpp = getStrategyDataQuery?.data?.data?.filter(
              (o) => o.risk_opportunity.id === strategy?.risk_opportunity?.id
            );

            return (
              <>
                <Collapse
                  collapsible="header"
                  expandIconPosition={"end"}
                  items={[
                    {
                      key: strategy?.id ?? Math.random(),
                      label: strategy?.risk_opportunity?.name ?? "-",
                      children: (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                          }}
                        >
                          <div className={classes.containerItem}>
                            <span className={classes.titleContainer}>
                              Risk Name{" "}
                              <span className={classes.valueContainer}>
                                {strategy?.risk_opportunity?.name ?? "-"}
                              </span>{" "}
                              <Tag
                                bordered={false}
                                color={getColor(
                                  strategy?.risk_opportunity?.urgency
                                )}
                              >
                                {strategy?.risk_opportunity?.urgency}
                              </Tag>
                            </span>
                            <span className={classes.titleContainer}>
                              {" "}
                              Risk Description{" "}
                              <span className={classes.valueContainer}>
                                {strategy?.risk_opportunity?.description}
                              </span>
                            </span>
                          </div>
                          {specificRisksOpp.map((item) => {
                            return (
                              <Collapse
                                collapsible="header"
                                items={riskOpportunity(item)}
                                bordered={false}
                                id={item.id}
                                expandIconPosition={"end"}
                              />
                            );
                          })}
                        </div>
                      ),
                      extra: (
                        <>
                          <Button
                            size="small"
                            color="primary"
                            variant="outlined"
                            style={{
                              fontSize: 12,
                            }}
                            disabled={
                              strategy?.risk_opportunity?.id !==
                              executedStrategy?.risk_opportunity?.id
                            }
                            onClick={() => {
                              executedStrategyMutation.mutate({
                                id: executedStrategy?.id,
                              });
                            }}
                          >
                            Execute Strategy
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
              </>
            );
          })}
        </Space>
      </div>
    </div>
  );
};
export default RiskOpportunity;
